import {Card, CardDescription, CardHeader, CardTitle} from "@/components/ui/card.tsx";
import {Button} from "@/components/ui/button.tsx";
import {X} from "lucide-react";
import {clsx} from "clsx";
import {Badge} from "@/components/ui/badge.tsx";
import {Progress} from "@/components/ui/progress.tsx";

export default function AttachmentCard({attachment, deleteAttachment, progress}: {
    attachment?: { id?: string, file_name: string, size: number | null, position: string | null },
    deleteAttachment?: (id?: string) => void,
    progress?: number
}) {
    if (!attachment) {
        return <></>
    }
    return <Card
        className={clsx("relative mt-3 pt-4 h-26 bg-white", (attachment.position == "ai" && "border-aiblue border-2"))}
        key={attachment.id}>
        {attachment.position == "ai" &&
            <Badge className={"absolute -top-3 -right-3 w-6 h-6"} variant={"ai"}>AI</Badge>}
        <CardHeader>
            <CardTitle>
                <div className={"flex items-center justify-between"}>
                    {attachment.id ?
                        <a href={'/api/attachment/' + attachment.id} target={'_blank'}
                           className={"pointer-events-auto"}>
                            <p>{decodeURI(attachment.file_name)}</p>
                        </a> : <p>{decodeURI(attachment.file_name)}</p>}
                    {deleteAttachment &&
                        <Button className={"pointer-events-auto"}
                                onClick={() => deleteAttachment?.(attachment.id)}
                                variant={'outline'}><X/></Button>
                    }
                </div>
            </CardTitle>
            <CardDescription>
                <div className={"flex justify-between"}>
                    <div>
                        {attachment.size ? ((attachment.size / 1024).toLocaleString('hu-HU', {maximumFractionDigits: 1}) + " kByte") : "Folyamatban..."}
                    </div>
                </div>
                {
                    progress != undefined &&
                    <div>
                        <Progress className={"bg-aiblue/20"} value={progress} fillClassName={"bg-aiblue"}/>
                    </div>
                }
            </CardDescription>
        </CardHeader>
    </Card>
}